const cards = [
  {
    title: '台北娜娜最新视频曝光，内容引发全网热议',
    desc: '台北娜娜本周发布的最新视频内容再次引爆网络，涉及多位圈内人士的惊人内幕，细节令人震惊。网友纷纷表示这是今年最劲爆的瓜。',
    tag: '台北娜娜',
    time: '3小时前',
    hot: true,
    image: 'https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20photography%20of%20entertainment%20breaking%20news%20concept%2C%20coral%20red%20and%20gold%20accents%2C%20abstract%20floating%20headlines%20and%20media%20elements%20on%20soft%20cream%20background%2C%20urgency%20and%20excitement%20mood%2C%20modern%20journalism%20aesthetic&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    title: '莫里秀全系列合集整理，时间线完整梳理',
    desc: '本站独家整理了莫里秀从出道至今的所有重要事件时间线，包含独家爆料的来龙去脉，让你一次性了解全部真相。',
    tag: '莫里秀',
    time: '5小时前',
    hot: false,
    image: 'https://readdy.ai/api/search-image?query=Editorial%20style%20image%20of%20timeline%20and%20archive%20collection%20concept%2C%20warm%20amber%20and%20terracotta%20color%20palette%2C%20abstract%20document%20stacks%20and%20chronological%20elements%20on%20clean%20light%20background%2C%20organized%20research%20aesthetic&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    title: '玩偶姐姐身份大起底，独家内幕深度分析',
    desc: '关于玩偶姐姐的真实身份一直是吃瓜群众最关心的话题之一。本文整理了大量独家线索和分析，带你揭开神秘面纱。',
    tag: '玩偶姐姐',
    time: '8小时前',
    hot: true,
    image: 'https://readdy.ai/api/search-image?query=Sophisticated%20editorial%20concept%20of%20mystery%20and%20investigation%20theme%2C%20warm%20coral%20and%20gold%20gradients%2C%20abstract%20silhouette%20and%20magnifying%20glass%20elements%20on%20soft%20neutral%20background%2C%20intriguing%20and%20elegant%20mood&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    title: '娱乐圈年度大瓜回顾，2025最全盘点',
    desc: '今年的娱乐圈堪称瓜田丰收年。从年初到现在的每一个重大爆料，我们都帮你整理好了，看看你错过了哪些精彩。',
    tag: '年度盘点',
    time: '12小时前',
    hot: false,
    image: 'https://readdy.ai/api/search-image?query=Warm%20editorial%20photography%20of%20year%20in%20review%20and%20retrospective%20concept%2C%20golden%20and%20terracotta%20tones%2C%20abstract%20calendar%20and%20milestone%20elements%20on%20clean%20cream%20background%2C%20reflective%20and%20elegant%20mood&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    title: '台北娜娜闺蜜圈大揭秘，关系网错综复杂',
    desc: '台北娜娜的社交圈一直是热门话题。本站深度调查了她与多位圈内人士的关系网络，揭示了许多不为人知的内幕。',
    tag: '台北娜娜',
    time: '1天前',
    hot: true,
    image: 'https://readdy.ai/api/search-image?query=Editorial%20style%20image%20of%20social%20network%20and%20connection%20concept%2C%20warm%20coral%20and%20amber%20color%20scheme%2C%20abstract%20interconnected%20nodes%20and%20lines%20on%20soft%20neutral%20background%2C%20modern%20data%20visualization%20aesthetic&width=800&height=500&seq=card-05&orientation=landscape',
  },
  {
    title: '莫里秀与玩偶姐姐的世纪交集，独家对比分析',
    desc: '两位热门人物之间是否有联系？我们对两人的公开资料进行了详细对比，发现了许多令人惊讶的共同点。',
    tag: '热门人物',
    time: '1天前',
    hot: false,
    image: 'https://readdy.ai/api/search-image?query=Modern%20editorial%20concept%20of%20comparison%20and%20analysis%20theme%2C%20warm%20golden%20and%20terracotta%20palette%2C%20abstract%20split%20screen%20and%20contrast%20elements%20on%20clean%20light%20background%2C%20balanced%20and%20professional%20aesthetic&width=800&height=500&seq=card-06&orientation=landscape',
  },
  {
    title: '吃瓜圈最新暗号解读，看懂的人都沉默了',
    desc: '最近吃瓜圈流传着各种暗号和隐喻，本站为你一一破解这些圈内黑话，让你从此吃瓜不再迷茫。',
    tag: '吃瓜文化',
    time: '2天前',
    hot: false,
    image: 'https://readdy.ai/api/search-image?query=Warm%20editorial%20photography%20of%20code%20and%20decryption%20concept%2C%20coral%20and%20gold%20accents%2C%20abstract%20cipher%20and%20puzzle%20elements%20on%20soft%20cream%20background%2C%20mysterious%20yet%20approachable%20mood%2C%20modern%20media%20style&width=800&height=500&seq=card-07&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门爆料
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            最新最热的吃瓜内容，实时更新不错过
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cards.map((item, i) => (
            <div
              key={i}
              className={`bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:bg-background-200/50 ${
                i === 0 ? 'md:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div className="flex flex-col sm:flex-row h-full">
                <div className={`relative overflow-hidden ${i === 0 ? 'sm:w-2/5' : 'sm:w-full sm:h-44'}`}>
                  <img
                    src={item.image}
                    alt={item.title}
                    className={`w-full object-cover transition-transform duration-500 hover:scale-105 ${
                      i === 0 ? 'h-48 sm:h-full' : 'h-40 sm:h-44'
                    }`}
                  />
                  {item.hot && (
                    <span className="absolute top-3 left-3 px-2 py-0.5 text-[11px] font-medium rounded-full bg-primary-500 text-white">
                      热榜
                    </span>
                  )}
                </div>
                <div className={`p-4 md:p-5 flex flex-col justify-center ${i === 0 ? 'sm:w-3/5' : ''}`}>
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className="px-2 py-0.5 text-[11px] rounded-full bg-accent-100 text-accent-700 font-medium">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2 leading-snug">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}